import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormProps, getRequiredValidationRule, getValidationErrorProps } from 'util/Form';

const VALUE_MAX_LENGTH = 300;

interface TextQuestionFormItemProps extends FormProps {
  fieldName: string;
  required?: boolean;
}

const TextQuestionFormItem: React.FunctionComponent<TextQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
  label = '',
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...getValidationErrorProps(error)}
          required={required}
          disabled={disabled}
          label={label}
          inputProps={{ maxLength: VALUE_MAX_LENGTH }}
        />
      )}
      name={fieldName}
      control={control}
      rules={{
        required: getRequiredValidationRule('your answer', false, required),
      }}
    />
  );
};
export default TextQuestionFormItem;
